import { GenerateSectionContentInput } from '@/api/gql/graphql';
import { QuestionOutput } from '@/api/gql/graphql';
import { HighlightOutput } from '@/api/gql/graphql';
import moduleIcon from '@/assets/icons/module.svg';
import summaryIcon from '@/assets/icons/resume.svg';
import audioIcon from '@/assets/icons/audio.svg';
import feedbackIcon from '@/assets/icons/feedback.svg';

export enum ContentType {
  Module = 'module',
  Summary = 'summary',
  Audio = 'audio',
  Feedback = 'feedback',
}

export enum GeneratorModuleItem {
  Module = 'Module',
  Summary = 'Summary',
  Audio = 'Audio',
  Evaluation = 'Evaluation',
  Feedback = 'Feedback',
}

export type Module = {
  section: GenerateSectionContentInput;
  highlights: HighlightOutput[];
  quizz: QuestionOutput[];
};

export const GENERATION_OPTIONS = [
  {
    icon: moduleIcon,
    title: 'Généré les modules',
    description: 'Modules + Quiz, évaluation etc.....',
    contentType: ContentType.Module,
  },
  {
    icon: summaryIcon,
    title: 'Généré le résumé',
    contentType: ContentType.Summary,
  },
  {
    icon: audioIcon,
    title: "Généré l'audio",
    contentType: ContentType.Audio,
  },
  {
    icon: feedbackIcon,
    title: 'Faire des feedback',
    contentType: ContentType.Feedback,
  },
];
